import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EffectHandlerService } from '@services/effect-handler.service';
import { ApiService } from '@state/api.service';
import {
  listMethodologies,
  listMethodologiesFailure,
  listMethodologiesSuccess,
} from '@state/methodologies/methodologies.actions';
import { switchMap } from 'rxjs/operators';


@Injectable()
export class MethodologiesEffects {
  actions$ = inject(Actions);
  api = inject(ApiService);
  handler = inject(EffectHandlerService);

  listMethodologies$ = createEffect(() => this.actions$.pipe(
    ofType(listMethodologies),
    switchMap(() => this.api.listMethodologies().pipe(
      this.handler.effectResponse({
        retry: listMethodologies(),
        success: (methodologies) => listMethodologiesSuccess({ methodologies }),
        failure: listMethodologiesFailure(),
        failureMessage: 'Could not load Methodologies',
      })
    ))
  ));
}
